import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="filter-reset"
export default class extends Controller {
  reset(event) {
    event.preventDefault();

    const form = this.element.closest("form");
    if (!form) return;

    form.querySelectorAll("input, select, textarea").forEach(el => {
      if (["submit", "button"].includes(el.type)) return;

      if (el.type === "checkbox" || el.type === "radio") {
        el.checked = false;
      } else {
        el.value = "";
      }
    });
  }
}
